import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name?: string;
  location?: string;
  product?: string;
  quote: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  quote
}: TestimonialProps) {
  return <div className="bg-emerald-950/40 p-6 rounded-2xl border border-emerald-800/40 flex flex-col h-full" data-id="element-23">
      <div className="flex items-center gap-4 mb-4" data-id="element-24">
        <div className="w-12 h-12 rounded-full bg-emerald-500/15 text-emerald-300 font-bold flex items-center justify-center text-lg shrink-0 border border-emerald-500/30" data-id="element-25">
          {initials}
        </div>
        <div data-id="element-26">
          <div className="flex text-amber-400 mb-1" data-id="element-27">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-28" />)}
          </div>
          {name && <p className="font-bold text-emerald-50 text-sm" data-id="element-29">{name}</p>}
          {location && <p className="text-xs text-emerald-400/70" data-id="element-30">{location}</p>}
        </div>
      </div>
      {product && <div className="mb-3" data-id="element-31">
          <span className="inline-block bg-emerald-500/10 text-emerald-300 text-xs px-2 py-1 rounded font-medium border border-emerald-500/20" data-id="element-32">
            {product}
          </span>
        </div>}
      <p className="text-emerald-100/80 italic text-sm leading-relaxed flex-1" data-id="element-33">
        "{quote}"
      </p>
    </div>;
}